import { connect } from 'react-redux'
import checklistSelector from './checklistSelector'
import requestAddChecklistItem from '../sagas/requestAddChecklistItem'
import requestAddChecklistItemArray from '../sagas/requestAddChecklistItemArray'
import requestPositionChecklistItem from '../sagas/requestPositionChecklistItem'
import requestConvertChecklistToSubCardGroup from '../sagas/requestConvertChecklistToSubCardGroup'
import Checklist from './Checklist'
import {
  set as setChecklist
} from '../redux/elements'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  checklistSelector,
  {
    requestAddChecklistItem,
    requestAddChecklistItemArray,
    requestPositionChecklistItem,
    requestConvertChecklistToSubCardGroup,
    setChecklist
  },
  null,
  {
    forwardRef: true,
  }
)(Checklist))
